module.exports = __webpack_public_path__ + "static/media/creatanium.054dd39a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/client_logo/creatanium.png
// module id = 29
// module chunks = 0